import axios from 'axios'
import {
  VERIFICATION_AUTH_TOKEN_KEY,
  CLIENT_AUTH_TOKEN_KEY,
  AGENT_AUTH_TOKEN_KEY,
} from '@/store/types'

const baseURL = import.meta.env.VITE_BASE_URI || 'http://localhost:9000'

const instance = axios.create({
  baseURL,
  withCredentials: true,
})

instance.interceptors.request.use(
  (config) => {
    let verificationToken = localStorage.getItem(VERIFICATION_AUTH_TOKEN_KEY)

    let clientToken = localStorage.getItem(CLIENT_AUTH_TOKEN_KEY)

    let agentToken = localStorage.getItem(AGENT_AUTH_TOKEN_KEY)

    if (!config.url.includes('http') || config.url.includes(baseURL)) {
      if (location.pathname.includes('/verifications/')) {
        if (verificationToken) {
          config.headers['Authorization'] = `Bearer ${verificationToken}`
        }
      } else if (location.pathname.includes('/agent/')) {
        if (agentToken) {
          config.headers['Authorization'] = `Token ${agentToken}`
        }
      } else if (location.pathname.includes('/config/')) {
        if (agentToken) {
          config.headers['Authorization'] = `Token ${agentToken}`
        }
      } else {
        if (clientToken) {
          config.headers['Authorization'] = `Bearer ${clientToken}`
        }
      }
    }

    if (config.url.includes('.html')) {
      config.baseURL = location.origin
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

export default instance
